export const EMAIL_REGEX =
  /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const E164_PARTIAL_INPUT_REGEX = /^(\+)?\d{0,15}$/;
export const E164_REGEX = /^(\+)[1-9]\d{11,15}$/;
export const LETTERS_ONLY_REGEX = /^[A-Za-z\s]+$/;

export function isValidEmail(value: string) {
  if (!value) return true;
  return EMAIL_REGEX.test(value);
}

export function sanitizeLettersOnly(value: string) {
  return value.replace(/[^A-Za-z\s]/g, '');
}
